/*
 * @Date: 2023-11-01 13:37:21
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-02-28 18:01:23
 * @FilePath: /nicee-web-tw/src/components/VoiceRoom/voiceRoomEvent.js
 * @Description: 语音房事件名
 */
const VoiceRoomEvent = {
  onSeatInfoListChange: 'onSeatInfoListChange', // 麦位更新
  enterSeat: 'enterSeat', // 上麦申请通过
  leaveSeat: 'leaveSeat', // 下麦
  initCurrentUserSeat: 'initCurrentUserSeat', // 初始化當前用戶的麥位信息
  rtcReady: 'rtcReady', // rtc初始化成功
  leaveRoom: 'leaveRoom', // 离开房间
  joinRoom: 'joinRoom', // 加入房间
  addNewMessage: 'addNewMessage', // 接收普通消息
  addVideoMessage: 'addVideoMessage', // 接收视频消息
  playVideo: 'playVideo', // 播放视频
  updateAskingMicQueue: 'updateAskingMicQueue', // 更新麦位申请列表
  userEnterSeat: 'userEnterSeat', // 有用戶的上麥被通過
  userJoinRoom: 'userJoinRoom', // 有用戶進入房間
  OnAdminChange: 'OnAdminChange', // 管理员身份变更
  onSeatChange: 'onSeatChange', // 座位变化
  clearSeat: 'clearSeat', // 清理麦位
  onMicChange: 'onMicChange', // 麦位变化
};
export default VoiceRoomEvent;
